import IconSpinner from './IconSpinner';

export default IconSpinner;
